// Urutan & metadata tab-tab Notification Settings. Murni, nol import.

export const NOTIFICATION_SETTINGS_TABS = [
  { key: 'topic', permission: 'master_notification_topic', title: 'Topic' },
  { key: 'template', permission: 'master_notification_template', title: 'Template' },
  { key: 'contact', permission: 'master_notification_contact', title: 'Contact' },
  { key: 'subscription', permission: 'master_notification_subscription', title: 'Subscription' },
  { key: 'alert-rule', permission: 'master_alert_rule', title: 'Alert Rule' },
];

// Tab yang bisa dibaca, urutan tetap sesuai NOTIFICATION_SETTINGS_TABS.
export function visibleNotificationTabs(allowedPermissions) {
  return NOTIFICATION_SETTINGS_TABS.filter((tab) => allowedPermissions.includes(tab.permission));
}

// Tab aktif dari query ?tab=, fallback ke tab pertama yang diizinkan.
export function resolveActiveTabKey(queryTab, visibleTabs) {
  const keys = visibleTabs.map((tab) => tab.key);
  return keys.includes(queryTab) ? queryTab : (keys[0] || null);
}
